<mat-tab-group
  #tabGroup
  (selectedTabChange)="handleTabChange($event)"
>
  <mat-tab label="Создать новый">
    <form
      class="form"
      [formGroup]="customerFormGroup()"
    >
      @for (field of customerFormFields; track $index) {
        <mat-form-field appearance="outline">
          <mat-label>{{ field.label }}</mat-label>
          <input
            matInput
            [type]="field.type"
            [formControlName]="field.fieldName"
          >
        </mat-form-field>
      }
    </form>
  </mat-tab>
  <mat-tab
    [label]="getCurrentCustomerTab()"
    [disabled]="!hasCustomers"
  >
    <div class="form">
      <mat-form-field
        class="form-search"
        appearance="outline"
      >
        <input
          matInput
          placeholder="Поиск"
          [(ngModel)]="searchValue"
          (blur)="searchChange()"
          (change)="searchChange()"
        >
        <mat-label>Поиск покупателя</mat-label>
      </mat-form-field>
      <div class="form-list">
        <mat-selection-list
          [multiple]="false"
          [(ngModel)]="selectedCustomer"
        >
          @for (customer of customers(); track $index) {
            <mat-list-option [value]="customer">
              <div>
                <div class="infos">
                  <div class="info">
                    <span class="info-title">Id: </span>
                    <span class="info-text">{{ customer.id }}</span>
                  </div>
                  <div class="info">
                    <span class="info-title">Имя:</span>
                    <span class="info-text">{{ customer.name }}</span>
                  </div>
                </div>
                <div class="urls">
                  <div class="info">
                    <img
                      src="assets/icons/telegram/telegram-icon-default.svg"
                      alt=""
                      width="16"
                      height="16"
                    >
                    <span class="info-text">
                      {{ customer.telegramLink }}
                    </span>
                  </div>
                  <div class="info">
                    <img
                      src="assets/icons/whatsapp/whatsapp-icon.svg"
                      alt=""
                      width="16"
                      height="16"
                    >
                    <span class="info-text">
                      {{ customer.whatsappLink }}
                    </span>
                  </div>
                </div>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
<div class="buttons-container">
  <button
    mat-button
    class="blogger-form-btn"
    color="primary"
    type="submit"
    [disabled]="customerFormGroup().invalid"
    (click)="handleAttach()"
  >
    {{ getTextButton() }}
  </button>
</div>
